export const isExternalLink = (href: string): boolean => {
    /*
        const unusedExternalProtocols = [
            'file://', 'data:', 'ws://', 'wss://', 'sms:', 'sip:', 'im:',
            'callto:', 'whatsapp:', 'skype:', 'slack:', 'bitcoin:', 'ethereum:',
            'ipfs:', 'ipns:', 'ssh://', 'rtsp://', 'sftp://', 'ldaps://',
            'gopher://', 'magnet:'
        ];
    */

    const externalProtocols = ['http://', 'https://', 'mailto:', 'tel:'];

    return externalProtocols.some(protocol => href.startsWith(protocol));
};
